import { CommonGet, CommonPost } from '../../../utils/CommonFetch';
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    getGroups,
    getOperationalEntityByGroupEntityID,
    getCollectionPointsByOperationentityGroupID,
    getFactoryItemApprovalData,
    getFactoryItemApprovalDetailData,
    getCollectionPointByOperationEntityId,
    getAllOperationEntitiesForDropDown,
    FactoryItemApprovalStatusUpdate,
    FactoryItemRejectStatusUpdate
};

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
                collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getOperationalEntityByGroupEntityID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID)
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return array;
}

async function getFactoryItemApprovalData(collectionPointID, statusID) {
    var model = {
        collectionPointID: parseInt(collectionPointID),
        statusID: parseInt(statusID),
    };
    const response = await CommonPost('/api/FactoryItem/GetFactoryItemApprovalData', null, model);
    return response.data;
}

async function getFactoryItemApprovalDetailData(collectionPointID, orderNumber) {
    var model = {
        collectionPointID: parseInt(collectionPointID),
        orderNumber: orderNumber
    };
    const response = await CommonPost('/api/FactoryItem/GetFactoryItemApprovalDetailData', null, model);
    return response.data;
}
async function getCollectionPointByOperationEntityId(groupID, operationEntityID) {
    var collectionPointArray = [];
    let filterModel = {
        operationEntityID: operationEntityID.toString(),
        groupID: groupID.toString()
    }
    var response = await CommonPost('/api/CollectionPoint/GetCollectionPointByOperationEntityId', null, filterModel);

    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }

    return collectionPointArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function FactoryItemApprovalStatusUpdate(saveData) {
    const response = await CommonPost('/api/FactoryItem/FactoryItemApprovalStatusUpdate', null, saveData);
    return response;
}

async function FactoryItemRejectStatusUpdate(saveData) {
    const response = await CommonPost('/api/FactoryItem/FactoryItemRejectStatusUpdate', null, saveData);
    return response;
}